import styled from 'styled-components'

import { gridGapSize } from './lib/styles/helpers';

export const Container = styled.div`
  margin: auto;
  max-width: 1400px;
  padding-left: ${gridGapSize}px;
  padding-right: ${gridGapSize}px;
`;

export const Row = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-right: -${gridGapSize / 2}px;
  margin-left: -${gridGapSize / 2}px;
`;

export const Col = styled.div`
  flex: ${props => props.size} 0 auto;
  flex-basis: 0;
  max-width: 100%;
  padding-left: ${gridGapSize / 2}px;
  padding-right: ${gridGapSize / 2}px;
`;

Col.defaultProps = {
  size: 1,
};



// WEBPACK FOOTER //
// ./src/Grid.js